(function( $, autoPlay ) {
	$( document ).ready(() => {
		(function($) {
			console.log( 'LOADED' );
			$('.scroll').click(function() {
				console.log( 'CLICKED' );
				if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
					if (target.length) {
						$('html,body').animate({
							scrollTop: target.offset().top
						}, 1000);
						return false;
					}
				}
			});
		} ( $ ) );
	} );

	$( document ).ready(() => {

		var $sliders = $('.hero-slider .hero-slider__slides')
		if ( $sliders.length > 0 && ! $('.hero-video').hasClass('active') ) {

			$sliders.on( 'init', () => {
			})

			$sliders.on( 'afterChange', ( e, slick, currentSlide ) => {
				$('#fill-loader').addClass('animate')

				$('.text-box .slide-num').text( currentSlide + 1 )
			})

			$sliders.slick({
				infinite: true,
				speed: 600,
				autoplay: autoPlay ? true : false,
				autoplaySpeed: autoPlay ? autoPlay : 4000,
				arrows: true,
				dots: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				appendDots: '.hero-slider .dots',
				appendArrows: '.hero-slider__controls',
				prevArrow:  '<button role="button" class="slick-prev reset" aria-label="Previous Slide"><i class="icon icon-arrow-up"></i></button>',
				nextArrow:  '<button role="button" class="slick-next reset" aria-label="Next Slide"><i class="icon icon-arrow-down"></i></button>',
			})


			/**
			 * When you swipe on the text-box, change the active slide.
			 */
			$('.hero-slider .text-box').swipe({

		        swipe( event, direction, distance, duration, fingerCount, fingerData ) {

					var $slider = $( this ).parent().prev()

		        	if ( 'left' === direction ) {
						$slider.slick('slickNext')
		        	} else if ( 'right' === direction ) {
						$slider.slick('slickPrev')
		        	}

		        },

		        allowPageScroll: 'vertical',

			})
		}

		if ( null !== document.getElementById('scroll-down-arrow') ) {

			document.getElementById('scroll-down-arrow').onclick = () => {
				var offset = document.querySelector('.hero-slider').nextElementSibling.offsetTop

				$('html, body').animate({
					scrollTop: offset
				}, 600 )
			}

		}

	})

})( jQuery, window.autoPlay );



// WEBPACK FOOTER //
// ./assets/js/components/layout/hero-slider.js